// extracted by mini-css-extract-plugin
export default {"expanded":"p6tgrh1oh2MRW_1xVFuc","itemTitle":"cB3loUiFp8FdMdIKtVDv","itemContent":"celVe_GnOWEZPSNe0y05","tooltipStyle":"OFOOlc3cyG1_mfUoKEeO"};